import client from "./http.client"
import store from "@/store"

class AuthService {
  async login(user) {
    return client.post("/api/login/", {
      email: user.email,
      password: user.password
    })
  }
  async endUserLogin(user) {
    return client.post(
      "/api/login/",
      {
        email: user.email,
        password: user.password
      },
      {
        headers: {
          "X-RevSetter-UType": "end-user"
        }
      }
    )
  }

  async magic_login(token) {
    return client.get(`/magic/login?token=${token}`)
  }
  async session_login(token) {
    return client.get(`/session/login?token=${token}`)
  }

  async logout() {
    return client.post("/api/logout/", {})
  }
  async recoverPassword(email) {
    return client.post("/api/password/reset/", { email: email })
  }

  async changePassword(old_password, new_password1, new_password2) {
    return client.post(`/api/password/change/`, { old_password, new_password1, new_password2 })
  }

  async resetPassword(uid, token, password1, password2) {
    return client.post(`/api/password/reset/confirm/${uid}/${token}/`, {
      uid: uid,
      token: token,
      new_password1: password1,
      new_password2: password2
    })
  }
  async joinTeam(uid, token, password1, password2) {
    return client.post("/api/invitation/join/", { uid: uid, token: token, new_password1: password1, new_password2: password2 })
  }
  async endUserJoin(uid, token, password1, password2) {
    return client.post("/api/end-user/join/", { uid: uid, token: token, new_password1: password1, new_password2: password2 })
  }
  async workspaceEndUserJoin(uid, token, password1, password2, workspace_id) {
    return client.post("/api/workspace/join/", {
      uid: uid,
      token: token,
      new_password1: password1,
      new_password2: password2,
      workspace_id: workspace_id
    })
  }
  async inviteTeamMembers(members) {
    return client.post("/api/invitation/send/", members)
  }
  async shareEndUserObject(data) {
    return client.post("/api/end-user/send/", data)
  }

  async fetchMe() {
    return client.get("/api/users/me/")
  }

  async fetchUsers(params = { page_size: 100 }) {
    return client.get("/api/users/", { params })
  }

  async updateUser(user_id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/users/${user_id}/`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  async changeUserRole(user_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/users/${user_id}/change-role/`, data)
  }
  async deleteUser(user_id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/users/${user_id}/`)
  }
  async updateOrganizationName(name) {
    return client.patch(`/api/organizations/${store.state.organization.id}/`, { name })
  }
  async updateOrganization(id, data) {
    return client.patch(`/api/organizations/${id}/`, data, { headers: { "Content-Type": "multipart/form-data" } })
  }
  async signWithGoogle(code, params) {
    return client.post("/accounts/google/login/callback/", { access_token: code }, { params })
  }
  async authorizeNylas(data) {
    return client.post("/accounts/google/auth/", data)
  }
  async checkOrganizationName(params = {}) {
    return client.get("/api/organizations/check-name/", { params })
  }
  async checkUserEmail(params = {}) {
    return client.get("/api/users/check-email/", { params })
  }
  async checkInviteCode(params = {}) {
    return client.get("/api/users/check-invite-code/", { params })
  }

  async sendEmailVerificationCode(data) {
    return client.post("/api/users/send-email-verification-code/", data)
  }

  async verifyEmail(data) {
    return client.post("/api/users/verify-email/", data)
  }
}

export default new AuthService()
